import list from 'src/modules/meditation/list/meditationListReducers';
import form from 'src/modules/meditation/form/meditationFormReducers';
import view from 'src/modules/meditation/view/meditationViewReducers';
import destroy from 'src/modules/meditation/destroy/meditationDestroyReducers';
import unarchive from 'src/modules/meditation/unarchive/meditationUnarchiveReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  unarchive,
});
